import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentTypeLookupComponent } from './payment-type-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [PaymentTypeLookupComponent],
  exports: [PaymentTypeLookupComponent]
})
export class PaymentTypeLookupModule { }
